import { useQuery, useMutation } from "@tanstack/react-query";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";

const getEmpAdditions = async ({
  companyCode,
  departmentCode = 0,
  allowanceCode = 0,
  typeCode = 0,
  locationCode,
}) => {
  // `${Api_EndPoints.GetEmpPayrollAddition}?CompanyCode=${companyCode}&DepartmentCode=${departmentCode}&AllowanceCode=${allowanceCode}&LocationCode=${locationCode}`
  if (companyCode && locationCode) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmpPayrollAddition}?CompanyCode=${companyCode}&DepartmentCode=${departmentCode}&AllowanceCode=${allowanceCode}&TypeCode=${typeCode}&LocationCode=${locationCode}`
    );
    return data;
  }

  return [];
};

const createEmpAddition = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.EmpAdditionCreation,
    input
  );
  return data;
};

const updateEmpAddition = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.EmpAdditionUpdate,
    input
  );
  return data;
};

export const useGetEmpAdditionsQuery = (input) => {
  console.log(input);
  return useQuery({
    queryKey: [Api_EndPoints.GetEmpPayrollAddition],
    queryFn: () => getEmpAdditions(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertEmpAdditionMutation = () => {
  return useMutation({
    mutationFn: createEmpAddition,
  });
};

export const useUpdateEmpAdditionMutation = () => {
  return useMutation({
    mutationFn: updateEmpAddition,
  });
};
